import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-claw",
  "use": "icon-leo-claw-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-claw\">\r\n<g transform=\"translate(-61.440 -61.440) scale(1.120000)\">\r\n<path d=\"M512 128l288 160v320L512 896 224 608V288L512 128zm0 118L320 352v208l192 192 192-192V352L512 246z\" />\r\n  <path d=\"M448 416h128v192H448V416z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-claw.svg
// module id = y+o8
// module chunks = 478